'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _constants = require('../../constants');
var _radioWrapper = require('./radio-wrapper');
var _radioWrapper2 = _interopRequireDefault(_radioWrapper);
var _radioClassic = require('./items/radio-classic');
var _radioClassic2 = _interopRequireDefault(_radioClassic);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Classic = function (_Component) {
  _inherits(Classic, _Component);
  function Classic() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Classic);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Classic.__proto__ || Object.getPrototypeOf(Classic)).call.apply(_ref, [this].concat(args))), _this), _this.renderOptions = function (selected, onChange) {
      return _this.props.options.map(function (option) {
        var value = typeof option === 'string' ? option : option.value;
        var text = typeof option === 'string' ? option : option.text;
        return _react2.default.createElement(_radioClassic2.default, {
          name: _this.props.name,
          value: value,
          text: text,
          onChange: onChange,
          selected: selected === value,
          key: value
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Classic, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        label = _props.label,
        name = _props.name,
        rest = _objectWithoutProperties(_props, ['label', 'name']);
      return _react2.default.createElement(_radioWrapper2.default, Object.assign({
        name: name,
        label: label,
        render: this.renderOptions
      }, rest));
    }
  }]);
  return Classic;
}(_react.Component);
Classic.propTypes = {
  name: _propTypes.string,
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  options: _constants.optionsPropTypes
};
Classic.defaultProps = {
  name: 'radio',
  label: 'Please choose an option',
  options: []
};
exports.default = Classic;